import { render, staticRenderFns } from "./FacetsApp.vue?vue&type=template&id=2f3b2d90"
import script from "./FacetsApp.vue?vue&type=script&lang=ts"
export * from "./FacetsApp.vue?vue&type=script&lang=ts"
import style0 from "./FacetsApp.vue?vue&type=style&index=0&id=2f3b2d90&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports